<template>
  <div>
    <app-nav></app-nav>
    <b-row>
      <b-col cols="1"></b-col>
      <b-col cols="10">
        <h2>Nouvelle liste de garde</h2>
        <div class="form-row">
          <div class="form-group">
            <label class="typo__label">Choix de l'année</label>
            <multiselect
              v-model="value_year"
              :options="options"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Choisir une année"
            >
            </multiselect>
          </div>
          <div class="form-group">
            <label class="typo__label">Choix du mois</label>
            <multiselect
              v-model="value_month"
              :options="options_month"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Choisir le mois"
            >
            </multiselect>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="form-group col-md-3">
      <label class="typo__label"></label>
      <button class="btn btn-primary btn-lg mt-4" @click="newList">
        Valider
      </button>
    </div>
  </div>
</template>

<script>
import router from "../router";
import AppNav from "./AppNav";
import Multiselect from "vue-multiselect";
import { longMonthNames } from "../constants/const";
import { CREATE_LISTE, CREATE_JOUR, ALL_GARDES } from "../constants/gardes";
import {
  addMonths,
  format,
  subMonths,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  getDaysInMonth,
  isWeekend
} from "date-fns";
export default {
  name: "gardesNew",
  components: {
    AppNav,
    Multiselect
  },
  data() {
    return {
      mois: "",
      annee: "",
      options: ["2023", "2024", "2025", "2026", "2027"],
      options_month: longMonthNames,
      value_month: "janvier",
      value_year: 2022
    };
  },
  methods: {
    async createDays(rangeOfDays, id) {
      for (let day of rangeOfDays) {
        const response = await this.$apollo.mutate({
          mutation: CREATE_JOUR,
          variables: {
            date: format(day, "yyyy-MM-dd"),
            listeId: id
          }
        });
      }
    },
    async newList() {
      var daysInMonth = getDaysInMonth(this.start);
      var self = this;
      let liste = await this.$apollo.mutate({
        mutation: CREATE_LISTE,
        variables: {
          date: format(this.start, "yyyy-MM-dd")
        },
        refetchQueries: [
          {
            query: ALL_GARDES
          }
        ]
      });
      this.createDays(this.date_range, liste.data.createListe.liste.id);

      this.$router.push({
        name: "GardesEdit",
        params: { id: liste.data.createListe.liste.id }
      });
    }
  },
  computed: {
    start: function() {
      return startOfMonth(
        new Date(
          this.value_year,
          longMonthNames.findIndex(x => x === this.value_month),
          1
        )
      );
    },
    end: function() {
      return endOfMonth(
        new Date(
          this.value_year,
          longMonthNames.findIndex(x => x === this.value_month),
          1
        )
      );
    },
    date_range: function() {
      return eachDayOfInterval({ start: this.start, end: this.end });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// gardesNew.vue?f155aa00